import { render, staticRenderFns } from "./AnnouncementsModal.vue?vue&type=template&id=5f22badf"
import script from "./AnnouncementsModal.vue?vue&type=script&lang=ts"
export * from "./AnnouncementsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports